import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { NavigationConfigType, navigationConfig } from 'app/fuse-configs/navigationConfig';

export const navigationAdapter = createEntityAdapter<NavigationConfigType>();

const emptyInitialState = navigationAdapter.getInitialState();
const initialState = navigationAdapter.upsertMany(emptyInitialState, navigationConfig);

const navigationSlice = createSlice({
  name: 'navigation',
  initialState,
  reducers: {
    setNavigation: navigationAdapter.setAll,
    resetNavigation: () => initialState,
    replaceNavigation: (state, action) => navigationAdapter.setAll(state, action.payload),
  },
});

export const { replaceNavigation, setNavigation } = navigationSlice.actions;

export default navigationSlice.reducer;
